import { render, staticRenderFns } from "./compete-analyse.vue?vue&type=template&id=8544635e&scoped=true&"
import script from "./compete-analyse.vue?vue&type=script&lang=js&"
export * from "./compete-analyse.vue?vue&type=script&lang=js&"
import style0 from "./compete-analyse.vue?vue&type=style&index=0&id=8544635e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8544635e",
  null
  
)

export default component.exports